import Commons from '../../../../Services/Common/Common';
const encryptWithDebug = (label, raw) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[POL_BASIC_01][encrypt-before] ${label}:`, raw);
  }
  return Commons.EncryptAES(raw);
};
export const POL_BASIC_02_Schema = {
  fields: {
    form: {
      chaebun: { initial: '', label: '채번' },
      seq: { initial: '', label: '순번' },
      goal: { initial: '', label: '전사목표' },
      gubun: { initial: '', label: '구분', required: 'Y' },
      gubun2: { initial: '', label: '구분상세' },
      target: { initial: '', label: '목표 및 성과지표' },
      department: { initial: '', label: '부서(담당자)' },
      performance: { initial: '', label: '실적/부진사유' },
      remark: { initial: '', label: '비고' },
    },
    grid: {
      no: { initial: '', label: 'NO' },
      chaebun: { initial: '', label: '채번' },
      seq: { initial: '', label: '순번' },
      gubun: { initial: '', label: '구분', required: 'Y' },
      gubun2: { initial: '', label: '구분상세' },

      planQuarter1: { initial: 'N', label: '1분기 계획' },
      planQuarter2: { initial: 'N', label: '2분기 계획' },
      planQuarter3: { initial: 'N', label: '3분기 계획' },
      planQuarter4: { initial: 'N', label: '4분기 계획' },

      performanceQuarter1: { initial: 'N', label: '1분기 실적' },
      performanceQuarter2: { initial: 'N', label: '2분기 실적' },
      performanceQuarter3: { initial: 'N', label: '3분기 실적' },
      performanceQuarter4: { initial: 'N', label: '4분기 실적' },

      target: { initial: '', label: '목표 및 성과지표' },
      department: { initial: '', label: '부서(담당자)' },
      percent: { initial: '', label: '달성률(%)' },
      performance: { initial: '', label: '실적/부진사유' },
      remark: { initial: '', label: '비고' },

      fileName: { initial: '', label: '파일명' },
      saveName: { initial: '', label: '저장파일명' },
      filePath: { initial: '', label: '파일경로' },
      previewFilePath: { initial: '', label: '미리보기경로' },

      createId: { initial: '', label: '생성자' },
      createDate: { initial: '', label: '생성일' },
      updateId: { initial: '', label: '수정자' },
      updateDate: { initial: '', label: '수정일' },
    },
    category: {
      categoryId: { initial: 0, label: '카테고리ID' },
      categoryName: { initial: '', label: '구분명', required: 'Y' },
      sortOrder: { initial: 1, label: '정렬순서' },
      deleteYn: { initial: 'N', label: '삭제여부' },
    },
    categoryItem: {
      itemId: { initial: 0, label: '아이템ID' },
      itemName: { initial: '', label: '아이템명' },
      sortOrder: { initial: 1, label: '정렬순서' },
      deleteYn: { initial: 'N', label: '삭제여부' },
    },
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      Year: (_, context) => Commons.EncryptAES(context.search?.year || ''),
      Quater: (_, context) => Commons.EncryptAES(context.search?.quater || ''),
    },

    search2: {
      Chaebun: (_, context) => Commons.EncryptAES(context.chaebun || ''),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search.searchText || ''),
    },

    // 조회 3은 모바일용

    search4: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      Year: (_, context) => Commons.EncryptAES(context.search?.year || ''),
      Quater: (_, context) => Commons.EncryptAES(context.search?.quater || ''),
    },

    save1: {
      Chaebun: (row) => Commons.EncryptAES(row?.chaebun || ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      Goal: (row) => Commons.EncryptAES(row?.goal || ''),
      Year: (_, context) => Commons.EncryptAES(context.search?.year || ''),
      Quater: (_, context) => Commons.EncryptAES(context.search?.quater || ''),
      Userid: (_, context) => context.userInfo?.userid,
    },

    save2: {
      Chaebun: (_, context) => Commons.EncryptAES(context.chaebun || ''),
      Seq: (row) => Commons.EncryptAES(row.seq || ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      Year: (_, context) => Commons.EncryptAES(context.search?.year || ''),
      Quater: (_, context) => Commons.EncryptAES(context.search?.quater || ''),
      Gubun: (row) => Commons.EncryptAES(row.gubun || ''),
      Gubun2: (row) => Commons.EncryptAES(row.gubun2 || ''),
      PlanQuarter1: (row) => Commons.EncryptAES(row.planQuarter1 || ''),
      PlanQuarter2: (row) => Commons.EncryptAES(row.planQuarter2 || ''),
      PlanQuarter3: (row) => Commons.EncryptAES(row.planQuarter3 || ''),
      PlanQuarter4: (row) => Commons.EncryptAES(row.planQuarter4 || ''),
      PerformanceQuarter1: (row) =>
        Commons.EncryptAES(row.performanceQuarter1 || ''),
      PerformanceQuarter2: (row) =>
        Commons.EncryptAES(row.performanceQuarter2 || ''),
      PerformanceQuarter3: (row) =>
        Commons.EncryptAES(row.performanceQuarter3 || ''),
      PerformanceQuarter4: (row) =>
        Commons.EncryptAES(row.performanceQuarter4 || ''),
      Target: (row) => Commons.EncryptAES(row.target || ''),
      Department: (row) => Commons.EncryptAES(row.department || ''),
      Percent: (row) => Commons.EncryptAES(row.percent?.toString() || ''),
      Performance: (row) => Commons.EncryptAES(row.performance || ''),
      Remark: (row) => Commons.EncryptAES(row.remark || ''),
      Userid: (_, context) => context.userInfo?.userid,
      FileName: (row) => Commons.EncryptAES(row.fileName || ''),
      SaveName: (row) => Commons.EncryptAES(row.saveName || ''),
      filePath: (row, context) =>
        Commons.EncryptAES(
          row.saveName
            ? `PolicyAndGoals/${context.search?.custCd}/POL_BASIC_02/${row.saveName}`
            : ''
        ),
    },

    save3: {
      // 카테고리 저장
      CategoryId: (row) =>
        encryptWithDebug('save3.CategoryId', row.categoryId || 0),
      CategoryName: (row) =>
        encryptWithDebug('save3.CategoryName', row.categoryName || ''),
      CustCd: (_, context) =>
        encryptWithDebug(
          'save3.CustCd',
          context.search?.custCd ||
            (context.userInfo?.authCd === 'ADMIN'
              ? context.search?.coCd
              : context.userInfo?.coCd || '')
        ),
      Year: (_, context) =>
        encryptWithDebug('save3.Year', context.search?.year || ''),
      Quater: (_, context) =>
        encryptWithDebug('save3.Quater', context.search?.quater || ''),
      SortOrder: (row) =>
        encryptWithDebug('save3.SortOrder', row.sortOrder || 0),
      UserId: (_, context) => context.userInfo?.userid,
    },

    save4: {
      ItemId: (row) => encryptWithDebug('save4.ItemId', row.itemId || 0),
      CategoryId: (row) =>
        encryptWithDebug('save4.CategoryId', row.categoryId || 0),
      ItemName: (row) => encryptWithDebug('save4.ItemName', row.itemName || ''),
      SortOrder: (row) =>
        encryptWithDebug('save4.SortOrder', row.sortOrder || 0),
      UserId: (_, context) => context.userInfo?.userid,
    },

    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || ''),
      Seq: (row) => Commons.EncryptAES(row.seq || ''),
    },
    delete2: {
      CategoryId: (row) =>
        encryptWithDebug('delete2.CategoryId', row.categoryId || 0),
    },
    delete3: {
      ItemId: (row) => Commons.EncryptAES(row.itemId || 0),
    },

    reorder2: {
      Chaebun: (_, context) => Commons.EncryptAES(context.chaebun || ''),
      Seq: (row) => Commons.EncryptAES(row.seq || ''),
      Gubun: (row) => Commons.EncryptAES(row.gubun || ''),
      Gubun2: (row) => Commons.EncryptAES(row.gubun2 || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },
  },
};
